import { render } from "./tender_nomenclature.vue?vue&type=template&id=44f29c52"
import script from "./tender_nomenclature.vue?vue&type=script&lang=js"
export * from "./tender_nomenclature.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/create/tabs/tender_nomenclature.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44f29c52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44f29c52', __exports__)) {
    console.log('reload')
    api.reload('44f29c52', __exports__)
  }
  
  module.hot.accept("./tender_nomenclature.vue?vue&type=template&id=44f29c52", () => {
    console.log('re-render')
    api.rerender('44f29c52', render)
  })

}


export default __exports__